<template>
	<window-view title="Organisation" v-on="$listeners" :width="400" :actions="_actions">
		<panel-view>
			<panel-sep-view>
				<grid-view>
					<input-view v-model="m.label" label="Navn" />
				</grid-view>			
			</panel-sep-view>
		</panel-view>
	</window-view>
</template>

<script>
	import organisation from '../../../model/organisation';

	export default {
		props: ['model', 'submit'],
		data() {
			return {
				id: '',
				m: organisation.model(),
			};
		},
		computed: {
			_actions() {
				const self = this;

				return [
					{
						label: 		'Annuller',
						emphasis: 	'text',
						action:		() => true
					},
					{
						label: 		'Gem',
						action: 	async () => {
							return self.submit(this.m);
						}
					}
				];
			}
		},
		async created() {
			console.log('m', this.model);
			this.m = {...this.m, ...this.model};
		}
	}
</script>

<style lang="scss" scoped>

</style>
